// Test IDs for the "Connect to your favourite agent" entry point and its dialog,
// which hands the user the fastn MCP server URL and the per-client snippet that
// goes with it.
//
// Renamed from connectClaudeTestIds: the dialog covers many clients now, so
// an id that says "claude" would be wrong on eleven of them.

import type { McpClientId } from "@/lib/mcp";

export const connectMcpTestIds = {
  /** Home-page trigger. */
  homeButton: "home-connect-mcp-button",
  /** Onboarding success screen, at the "now use it" moment. */
  onboardingButton: "onboarding-connect-mcp-button",
  /** Top-bar trigger, present on every dashboard page for eligible roles. */
  topbarButton: "topnav-connect-mcp-button",

  /** Settings > MCP server, the linkable copy of the dialog. */
  settingsPage: "settings-mcp-page",

  modal: "connect-mcp-modal",
  modalOverlay: "connect-mcp-modal-overlay",
  modalTitle: "connect-mcp-modal-title",
  modalDescription: "connect-mcp-modal-description",
  modalCloseButton: "connect-mcp-modal-close-button",

  /** The client picker, split into the recommended group and the rest. */
  gridRecommended: "connect-mcp-client-grid-recommended",
  grid: "connect-mcp-client-grid",

  /** The one value every client needs, whatever shape it wants it in. */
  serverUrlInput: "connect-mcp-server-url-input",
  serverUrlCopyButton: "connect-mcp-server-url-copy-button",
  serverUrlCopyErrorMessage: "connect-mcp-server-url-copy-error-message",

  /* Per client. Suffixed by the client's own id so a test names the tool it
     means rather than an index that shifts when the list is reordered. */
  clientTile: (id: McpClientId): string => `connect-mcp-client-${id}-tile`,
  clientPanel: (id: McpClientId): string => `connect-mcp-client-${id}-panel`,
  clientInstallButton: (id: McpClientId): string => `connect-mcp-client-${id}-install-button`,
  /* Indexed like the snippets beside it: altLinks is an array, and two
     unindexed ids on one client make any spec targeting them ambiguous. */
  clientAltLink: (id: McpClientId, i: number): string =>
    `connect-mcp-client-${id}-alt-link-${i}`,
  clientSteps: (id: McpClientId): string => `connect-mcp-client-${id}-steps`,
  clientNote: (id: McpClientId): string => `connect-mcp-client-${id}-note`,
  /* Snippets are indexed: a client can have both a command and a config file,
     and they are ordered, not named, in the registry. */
  clientSnippetInput: (id: McpClientId, i: number): string =>
    `connect-mcp-client-${id}-snippet-${i}-input`,
  clientSnippetCopyButton: (id: McpClientId, i: number): string =>
    `connect-mcp-client-${id}-snippet-${i}-copy-button`,
  clientSnippetCopyErrorMessage: (id: McpClientId, i: number): string =>
    `connect-mcp-client-${id}-snippet-${i}-copy-error-message`,
} as const;
